module.exports = __webpack_public_path__ + "img/position_liucheng_bg.b9df63a1.png";